// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Switch_text-gradient__oW2kx","switch":"Switch_switch__ATxnv","input":"Switch_input__5xGQ7","inner":"Switch_inner__2YsC7","box":"Switch_box__3wftP"};